import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Operations } from 'src/app/_models/Operations/Operations';
import { VenueModelResponse } from 'src/app/_models/Venue/VenueModel';
import { ApiService } from 'src/app/_services/api.service';

@Component({
  selector: 'app-multi-select-venue',
  templateUrl: './multi-select-venue.component.html',
  styleUrls: ['./multi-select-venue.component.scss']
})
export class MultiSelectVenueComponent implements OnInit {

  @Input() list:any[] = [];
  public venuesList: VenueModelResponse[] = [];
  @Input() operation:number = Operations.Add;
  @Input() checkedItems: string[] | undefined;
  loading: Boolean = false;

 
  @Output() shareCheckedList = new EventEmitter();

  checkedList: any[];

  constructor(private apiService: ApiService) {
    this.checkedList = [];
  }

  ngOnInit(): void {
    switch(this.operation){
      case Operations.Add: {
        this.fetchVenues();
        break;
      }
      case Operations.Edit: {
        this.fetchVenues();
        this.checkIfPopulated();
        // this.loading = false;
        break;
      }
      case Operations.Read: {
        this.fetchVenues();
        this.checkIfPopulated();
        break;
      }
    }
  }

  fetchVenues() {
    this.loading = true;
    this.apiService.listVenuesForCombo().subscribe((response)=>{     
      this.venuesList = response;
      this.loading = false;
    });
    
  }

  checkIfPopulated() {
    if(this.checkedItems){
        this.checkedItems.map((id)=>{
            this.checkedList.push(id);
        })
      }
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }

}
